import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=7250d0c1&scoped=true&lang=pug"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7250d0c1",
  null
  
)

export default component.exports